import { render } from "./GenresList.vue?vue&type=template&id=c198f22e&scoped=true"
import script from "./GenresList.vue?vue&type=script&lang=js"
export * from "./GenresList.vue?vue&type=script&lang=js"

import "./GenresList.vue?vue&type=style&index=0&id=c198f22e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c198f22e"]])

export default __exports__